import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { FaPhoneAlt, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { audio_modal } from "../../Pages/actions/video_audio_modal";
import socketModel from "../../models/socketModel";
import { useNavigate } from "react-router-dom";
import methodModel from "../../methods/methods";
const AudioCallRingModal = ({ isOpen, setIsOpen, roomId, CallingUserData = {} }) => {
    const history = useNavigate()
    const user = useSelector(state => state.user);
    const [RoomDetails, setRoomDetails] = useState({})
    const dispatch = useDispatch();
    const chats = useSelector((state) => state.chats?.data)
    useEffect(() => {
        setRoomDetails(chats?.find((_data) => _data?.room_id === roomId))
    }, [roomId])

    const closeModal = () => {
        setIsOpen(false)
        if (!RoomDetails?.isGroupChat) {
            socketModel.emit('stop-voice-call', {
                room_id: RoomDetails?.room_id, user_id: user?.id,
            })
            dispatch(audio_modal(false))
        }
    };

    const acceptCall = () => {
        history(`/chat?room_idd=${roomId}&voiceCall=true`)
        setIsOpen(false)
         dispatch(audio_modal(false))
    };

    // const declineCall = () => {
    //     closeModal();
    // };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={closeModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm" />
                </Transition.Child>

                <div className="fixed inset-0 flex items-center justify-center p-4">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all">
                            <Dialog.Title
                                as="h3"
                                className="text-lg font-medium leading-6 text-gray-900"
                            >
                                {/* Incoming Audio Call */}
                            </Dialog.Title>
                            <div className="mt-4 text-center">
                                <img
                                    src={methodModel.userImg(CallingUserData?.user_image)}
                                    className="object-cover w-16 h-16 mb-2 m-auto rounded-full"
                                />
                            </div>
                            <div className="mt-4 text-center">
                                <p className="text-gray-500">{CallingUserData?.name}...</p>
                            </div>
                            <div className="mt-6 flex items-center justify-center gap-4">
                                <button
                                    className="flex items-center justify-center gap-2 rounded-full bg-primary px-6 py-3 text-white hover:bg-green-600"
                                    onClick={acceptCall}
                                >
                                    <FaPhoneAlt className="w-5 h-5" />
                                    Accept
                                </button>
                                <button
                                    className="flex items-center justify-center gap-2 rounded-full bg-red-500 px-6 py-3 text-white hover:bg-red-600"
                                    onClick={closeModal}
                                >
                                    <FaTimes className="w-5 h-5" />
                                    Decline
                                </button>
                            </div>
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>

    );
};

export default AudioCallRingModal;
